module.exports = __webpack_public_path__ + "static/media/corporate.0cf4b3aa.svg";